import { render, staticRenderFns } from "./NlpTwitter.vue?vue&type=template&id=86da6eb4"
import script from "./NlpTwitter.vue?vue&type=script&lang=js"
export * from "./NlpTwitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports